import { Community } from '@/models/CommunityModel';
import { client } from './API';
import { ENVIRONMENTAL_VARIABLES } from '@/utils/Environment';

/**
 * @returns list of communities
 */
export const fetchCommunities = (): Promise<Community[]> => {
  return client.get(`${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/communities`).then((response) => response.data);
};
